import { Box, CircularProgress } from '@mui/material';

const CustomSpinner = ({
  color,
  size,
}: {
  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'inherit';
  size?: number | string;
}) => {
  return (
    <Box flex={1} display={'flex'} alignItems={'center'} justifyContent={'center'}>
      <CircularProgress sx={{color: "primary.main"}} size={size} />
    </Box>
  );
};

export default CustomSpinner;
